import { render, staticRenderFns } from "./Desktop_new.vue?vue&type=template&id=b378849c&scoped=true"
import script from "./Desktop_new.vue?vue&type=script&lang=js"
export * from "./Desktop_new.vue?vue&type=script&lang=js"
import style0 from "./Desktop_new.vue?vue&type=style&index=0&id=b378849c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b378849c",
  null
  
)

export default component.exports